import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

export const PerformanceRuleDescriptionCellRenderer = ({ data: { actions } }) => {
    const action = actions[0];
    const { actionType, budgetAdditionalData } = action;
    const changeValue = budgetAdditionalData?.changeValue;
    const { currency } = useAccount();
    const messageId = budgetAdditionalData
        ? `performance.rule.report.description.${actionType}.${budgetAdditionalData.changeType}`
        : `performance.rule.report.description.${actionType}`;
    return <FormattedMessage id={messageId} values={{ changeValue, currency }} />;
};
